const STORAGE_KEY = 'expert_login_emails';
const MAX_EMAILS = 10;

export const getStoredExpertEmails = (): string[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const storeExpertEmail = (email: string): void => {
  if (!email || !email.includes('@')) return;

  try {
    const emails = getStoredExpertEmails();
    const normalizedEmail = email.toLowerCase();
    if (!emails.some((e) => e.toLowerCase() === normalizedEmail)) {
      const newEmails = [email, ...emails].slice(0, MAX_EMAILS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newEmails));
    }
  } catch {
    // Silently fail if localStorage is not available
  }
};
